var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcoParkingBayService = function SvgIcoParkingBayService(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (/*#__PURE__*/React.createElement("svg", _extends({
      width: 48,
      height: 48,
      viewBox: "0 0 48 48",
      fill: "none",
      ref: svgRef
    }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#clip0)"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M46 36H43V39H38.12C38.3852 39 38.6396 38.8946 38.8271 38.7071C39.0146 38.5196 39.12 38.2652 39.12 38V35H42V23C41.9974 22.4487 41.843 21.9089 41.5537 21.4396C41.2644 20.9704 40.8514 20.5899 40.36 20.34L37.09 9C36.9072 8.4252 36.548 7.9226 36.0633 7.56358C35.5786 7.20456 34.9931 7.00736 34.39 7H11.59C10.9869 7.00736 10.4014 7.20456 9.91672 7.56358C9.43204 7.9226 9.0728 8.4252 8.89 9L5.62 20.35C5.13387 20.6018 4.72592 20.9819 4.44036 21.449C4.1548 21.9162 4.00251 22.4525 4 23V35H7.12V38C7.12 38.2652 7.22536 38.5196 7.41289 38.7071C7.60043 38.8946 7.85478 39 8.12 39H2V42H46V39H48.12V36H46ZM11.72 10H34.25L37.14 20H8.84L11.72 10ZM7 32V23H39V32H7ZM12.12 39C12.3852 39 12.6396 38.8946 12.8271 38.7071C13.0146 38.5196 13.12 38.2652 13.12 38V35H33.12V38C33.12 38.2652 33.2254 38.5196 33.4129 38.7071C33.6004 38.8946 33.8548 39 34.12 39H12.12Z",
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.62 27C15.62 26.6022 15.462 26.2206 15.1807 25.9393C14.8994 25.658 14.5178 25.5 14.12 25.5H10.62C10.2222 25.5 9.84064 25.658 9.55933 25.9393C9.27803 26.2206 9.12 26.6022 9.12 27C9.12 27.3978 9.27803 27.7794 9.55933 28.0607C9.84064 28.342 10.2222 28.5 10.62 28.5H14.12C14.5178 28.5 14.8994 28.342 15.1807 28.0607C15.462 27.7794 15.62 27.3978 15.62 27Z",
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M31.62 28.5H35.12C35.5178 28.5 35.8994 28.342 36.1807 28.0607C36.462 27.7794 36.62 27.3978 36.62 27C36.62 26.6022 36.462 26.2206 36.1807 25.9393C35.8994 25.658 35.5178 25.5 35.12 25.5H31.62C31.2222 25.5 30.8406 25.658 30.5593 25.9393C30.278 26.2206 30.12 26.6022 30.12 27C30.12 27.3978 30.278 27.7794 30.5593 28.0607C30.8406 28.342 31.2222 28.5 31.62 28.5Z",
      fill: "currentColor"
    }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "clip0"
    }, /*#__PURE__*/React.createElement("rect", {
      width: 48,
      height: 48,
      fill: "white"
    })))))
  );
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return (/*#__PURE__*/React.createElement(SvgIcoParkingBayService, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/ico_parking_bay_service.6261e22a.svg";
export { ForwardRef as ReactComponent };